const GRID_INTENSITY_META_URL = 'https://api.ourworldindata.org/v1/indicators/1077602.metadata.json';
const GRID_INTENSITY_DATA_URL = 'https://api.ourworldindata.org/v1/indicators/1077602.data.json';

let cachedDataset = null;
let datasetPromise = null;

const loadGridIntensityDataset = () => {
  if (cachedDataset) {
    return Promise.resolve(cachedDataset);
  }
  if (datasetPromise) {
    return datasetPromise;
  }

  datasetPromise = Promise.all([
    fetch(GRID_INTENSITY_META_URL).then((response) => {
      if (!response.ok) {
        throw new Error(`Grid intensity metadata request failed (${response.status})`);
      }
      return response.json();
    }),
    fetch(GRID_INTENSITY_DATA_URL).then((response) => {
      if (!response.ok) {
        throw new Error(`Grid intensity data request failed (${response.status})`);
      }
      return response.json();
    })
  ])
    .then(([metaJson, dataJson]) => {
      const entityValues = metaJson?.dimensions?.entities?.values ?? [];
      const entities = entityValues
        .filter((item) => item?.name)
        .map((item) => ({
          id: item.id,
          name: item.name,
          code: item.code ?? ''
        }));

      cachedDataset = {
        entities,
        values: dataJson?.values ?? [],
        years: dataJson?.years ?? [],
        entityIds: dataJson?.entities ?? []
      };

      return cachedDataset;
    })
    .finally(() => {
      datasetPromise = null;
    });

  return datasetPromise;
};

const findEntityMatch = (entities, term) => {
  const normalized = term.trim().toLowerCase();
  if (!normalized) return null;

  const exactMatch = entities.find(
    (entity) =>
      entity.name.toLowerCase() === normalized ||
      (entity.code && entity.code.toLowerCase() === normalized)
  );
  if (exactMatch) return exactMatch;

  return entities.find((entity) => entity.name.toLowerCase().includes(normalized)) || null;
};

const getLatestValueForEntity = (dataset, entityId) => {
  let latestYear = null;
  let latestValue = null;

  for (let i = 0; i < dataset.values.length; i += 1) {
    if (dataset.entityIds[i] !== entityId) continue;
    const value = dataset.values[i];
    const year = dataset.years[i];
    if (value === null || typeof year === 'undefined') continue;
    if (latestYear === null || year > latestYear) {
      latestYear = year;
      latestValue = value;
    }
  }

  if (latestValue === null) return null;
  return { latestYear, latestValue };
};

export const getLatestGridIntensityForCountry = async (countryTerm) => {
  if (!countryTerm) return null;
  const dataset = await loadGridIntensityDataset();
  const matched = findEntityMatch(dataset.entities, countryTerm);
  if (!matched) return null;

  const latest = getLatestValueForEntity(dataset, matched.id);
  if (!latest) return null;

  return {
    countryName: matched.name,
    countryCode: matched.code,
    year: latest.latestYear,
    valueKg: latest.latestValue / 1000
  };
};
